import { useIntl } from "react-intl";

const ChangeCalendar = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.ChangeCalendar.header",
            defaultMessage: "Change calendar"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.ChangeCalendar.body",
            defaultMessage:
                "Visualize and schedule changes happening across your organization to provide visibility and avoid conflicts."
        })
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
        </>
    );
};

export default ChangeCalendar;
